import { GlobalViewGetters } from './partials/global_view'
import { UserGroupGetters } from './partials/user_groups'
import { UserNewsGetters } from './partials/news'
import { UserPermissionsGetter } from './partials/permissions'
import { UserProfileGetters } from './partials/user-profile'
import { UserTeamsGetters } from './partials/teams'

export const UserGetters = {
  ...GlobalViewGetters,
  ...UserGroupGetters,
  ...UserNewsGetters,
  ...UserProfileGetters,
  ...UserPermissionsGetter,
  ...UserTeamsGetters,

  currentUser: (_, __, ___, rootGetters) => {
    return rootGetters.currentUser
  },
}
